import connector from 'Utils/connector';
import { setBreadcrumbs, resetBreadcrumbs } from '../redux/actions/app';
import { hasBreadcrumbs } from '../redux/selectors/breadcrumbs';

export default (Component) =>
  connector({
    selectors: { hasBreadcrumbs },
    actions: { setBreadcrumbs, resetBreadcrumbs },
  })(Component);
